import * as React from 'react';

export default function PhraseColoring(props: {
    phrase: string,
    phraseColoring: string | undefined,
}) {
    const { phrase, phraseColoring } = props;
    if (!phraseColoring)
        return <span>{phrase}</span>;

    const spans = [];
    for (let i = 0; i < phrase.length && i < phraseColoring.length;) {
        let className = '';
        const short = phraseColoring[i] === '1';
        const shortStressed = phraseColoring[i] === '2';
        const shortSecondaryStressed = phraseColoring[i] === '3';

        const long = phraseColoring[i] === '4';
        const longStressed = phraseColoring[i] === '5';
        const longSecondaryStressed = phraseColoring[i] === '6';

        const silent = phraseColoring[i] === '9';

        if (shortStressed)
            className = 'phrase-stressed';
        else if (shortSecondaryStressed)
            className = 'phrase-secondary-stressed';
        else if (long)
            className = 'phrase-long';
        else if (longStressed)
            className = 'phrase-long-stressed';
        else if (longSecondaryStressed)
            className = 'phrase-long-secondary-stressed';
        else if (silent)
            className = 'phrase-silent';

        if (!className) {
            // Accumulate consecutive non-stressed, non-long characters
            let start = i;
            while (i < phrase.length && i < phraseColoring.length && (phraseColoring[i] === '0' || phraseColoring[i] === '1'))
                i++;

            spans.push(<span key={start}>{phrase.slice(start, i)}</span>);
        }
        else {
            spans.push(<span key={i} className={className}>{phrase[i]}</span>);
            i++;
        }
    }
    return <>{spans}</>;
}
